import React, { useEffect, useState } from "react"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import ProjectDetails from "../../Projects/EditProject/ProjectDetails"
import { fetchData, FetchPostData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import Swal from "sweetalert2"
import "../../../../assets/css/Work/developmentSection.css"
import Loader from "pages/Separate/Loader"
const ExistingMaintenanceScreen = ({ onUpdate }) => {
  const [projectResponse, setProjectResponse] = useState(null)
  const [projectDetails, setProjectDetail] = useState(null)
  const [isLoading, setLoading] = useState(false)
  const toggleLoading = loading => {
    setLoading(loading)
  }

  // Initialize projectResponse with a compatible structure
  const fetchProjects = async () => {
    const user_id = localStorage.getItem("auth_id")
    const roleId = secureLocalStorage.getItem("auth_role")
    const res = await fetchData(
      toggleLoading,
      `unplanProjects/${user_id}/${roleId}`,
      token
    )
    if (res?.success) {
      const projects = res?.data?.projects
      setProjectDetail(projects[0])
    }
  }
  useEffect(() => {
    fetchProjects()
  }, [])
  useEffect(() => {
    if (!projectResponse) {
      setProjectResponse({
        data: {
          data: {
            newProject: projectDetails,
          },
        },
      })
    }
  }, [projectResponse])
  const token = secureLocalStorage.getItem("auth_token")

  const handleProjectResponse = response => {
    setProjectResponse(response)
  }

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="mt-140">
        <Container fluid>
          <Row>
            <Col lg={12} className="p-0">
              <ProjectDetails
                toggleLoading={toggleLoading}
                onUpdate={onUpdate}
                onProjectResponse={handleProjectResponse}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ExistingMaintenanceScreen
